import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { FormElementBase } from '../form-element-base';

@Component({
  selector: 'select-list',
  templateUrl: './select-list.component.html',
  styleUrls: ['./select-list.component.scss']
})
export class SelectListComponent extends FormElementBase {
  constructor() {
    super();
  }
}
